var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-button',{attrs:{"type":"secondary"},on:{"click":_vm.downloadModel}},[_vm._v("Download interaction model")])
}
var staticRenderFns = []

export { render, staticRenderFns }